module.exports = "/images/marking-icon-checkbox-checked_new.svg?6731702214e69f4774ccfaa3a5938d8d";